import { DistanceSlider, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import type { UserFilters } from "../types";

interface DistanceFilterProps {
  value: UserFilters["distance"];
  onChange: (value: UserFilters["distance"]) => void;
}

export function DistanceFilter(props: DistanceFilterProps) {
  const { value, onChange } = props;

  return (
    <Stack spacing={5}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Text semibold variant="body1">
          Distance From Home
        </Text>
        <Text
          variant="body2"
          sx={(theme) => ({
            border: `1px solid ${theme.palette.border?.subtle}`,
            borderRadius: theme.borderRadius?.xSmall,
            padding: 3,
          })}
        >
          {value} miles
        </Text>
      </Stack>

      <Stack>
        <DistanceSlider
          aria-label="Shift Filters Distance Slider"
          value={value}
          options={[10, 50, 100, 150]}
          step={10}
          max={150}
          min={10}
          onChange={(_event, value) => {
            onChange(value as number);
          }}
        />
      </Stack>
    </Stack>
  );
}
